import React from 'react'
import { AccountsLayout } from '../components/layout'
import { InputField, MultiLineField } from 'cwp-components/forms'
import { useForm } from 'react-hook-form'
import { BsTrash, BsUpload } from 'react-icons/bs'
import { Avatars } from 'assets/avatars'
import { useNavigate } from 'react-router-dom'

const ChamberManagerCreation = () => {
  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields },
    trigger,
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
  })

  const onSubmit = () => {
    navigate('/accounts/chamber/offices')
  }
  return (
    <AccountsLayout>
      <div className='relative md:space-y-[48px] space-y-[28px] md:w-[900px] !m-auto md:p-[60px] p-[20px] bg-white rounded-[20px] shadow-[-0.8px_-0.8px_16px_0px_rgba(0,0,0,0.25)]'>
        <div className='flex justify-between'>
          <h1 className='md:text-[24px] text-[16px] font-bold'>
            Profile creation
          </h1>
          <span className='md:text-[16px] text-[14px] text-[#3E75BC]'>
            Account manager's profile
          </span>
        </div>
        <div className='flex items-start justify-between'>
          <div className='flex items-center md:gap-[17px] gap-[8px]'>
            <img
              className='md:w-[80px] w-[40px] md:h-[80px] h-[40px]'
              src={Avatars._Dummy}
              alt=''
            />
            <div className='space-y-[6px] md:text-[16px] text-[12px] text-[#001A3D]'>
              <p className=''>
                <BsUpload className=' inline-flex' /> Upload manager's logo
              </p>
              <p>
                <BsTrash className='inline-flex' /> Delete
              </p>
            </div>
          </div>
          <p
            onClick={() => navigate('/accounts/verification')}
            className=' cursor-pointer md:text-[16px] text-[12px] text-[#001A3D] flex items-center gap-[6px] '
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
            >
              <g clip-path='url(#clip0_10132_37948)'>
                <path
                  d='M11.9917 3.26391C12.131 3.60079 12.3983 3.86857 12.735 4.00838L13.9156 4.49738C14.2525 4.63694 14.5202 4.90461 14.6597 5.24153C14.7993 5.57844 14.7993 5.95699 14.6597 6.29391L14.1711 7.47362C14.0315 7.81069 14.0313 8.18962 14.1715 8.52652L14.6593 9.70589C14.7285 9.87276 14.7641 10.0516 14.7642 10.2323C14.7642 10.4129 14.7286 10.5918 14.6595 10.7587C14.5904 10.9256 14.489 11.0772 14.3613 11.2049C14.2335 11.3326 14.0819 11.4339 13.9149 11.503L12.7352 11.9916C12.3983 12.1309 12.1306 12.3983 11.9907 12.735L11.5017 13.9156C11.3622 14.2525 11.0945 14.5202 10.7576 14.6597C10.4207 14.7993 10.0421 14.7993 9.70522 14.6597L8.5255 14.1711C8.18858 14.0318 7.81016 14.0321 7.47345 14.1718L6.29289 14.6601C5.95616 14.7994 5.57794 14.7993 5.2413 14.6598C4.90466 14.5204 4.63713 14.253 4.49748 13.9165L4.00833 12.7356C3.86903 12.3987 3.60165 12.1309 3.26497 11.9911L2.08441 11.5021C1.74764 11.3626 1.48005 11.0951 1.34044 10.7584C1.20084 10.4216 1.20065 10.0433 1.33991 9.7064L1.82857 8.52668C1.96778 8.18976 1.9675 7.81134 1.82778 7.47463L1.33983 6.29322C1.27064 6.12635 1.23502 5.94748 1.23499 5.76684C1.23496 5.5862 1.27053 5.40732 1.33966 5.24043C1.40879 5.07354 1.51012 4.9219 1.63788 4.79419C1.76563 4.66648 1.9173 4.56519 2.08421 4.49612L3.26393 4.00746C3.60052 3.86829 3.86814 3.60124 4.00805 3.26495L4.49705 2.08439C4.63661 1.74748 4.90428 1.4798 5.2412 1.34025C5.57811 1.20069 5.95666 1.20069 6.29358 1.34025L7.47329 1.8289C7.81022 1.96811 8.18863 1.96783 8.52535 1.82811L9.70641 1.341C10.0433 1.20153 10.4217 1.20156 10.7586 1.34108C11.0954 1.48061 11.3631 1.74821 11.5027 2.08503L11.9918 3.26595L11.9917 3.26391Z'
                  fill='#A0ABBE'
                />
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M10.8722 6.07746C10.9701 5.92357 11.003 5.73706 10.9634 5.55897C10.9239 5.38087 10.8152 5.22577 10.6613 5.1278C10.5074 5.02982 10.3209 4.99699 10.1428 5.03653C9.96473 5.07607 9.80963 5.18474 9.71166 5.33863L7.01941 9.56905L5.78741 8.02905C5.67351 7.88658 5.50768 7.7952 5.3264 7.775C5.14512 7.7548 4.96325 7.80744 4.82078 7.92134C4.67832 8.03524 4.58693 8.20107 4.56673 8.38234C4.54653 8.56362 4.59917 8.7455 4.71307 8.88796L6.54641 11.1796C6.61473 11.2651 6.70249 11.3331 6.80237 11.3779C6.90226 11.4226 7.01139 11.4429 7.12069 11.437C7.22998 11.4311 7.33629 11.3991 7.43076 11.3438C7.52523 11.2886 7.60513 11.2115 7.66382 11.1191L10.8722 6.07746Z'
                  fill='white'
                />
              </g>
              <defs>
                <clipPath id='clip0_10132_37948'>
                  <rect width='16' height='16' fill='white' />
                </clipPath>
              </defs>
            </svg>
            Click to verify
          </p>
        </div>

        <form
          onSubmit={handleSubmit(onSubmit)}
          className='grid md:grid-cols-2 md:gap-[50px] gap-[10px]'
        >
          <div className='flex flex-col item-center space-y-[12px]'>
            <InputField
              register={register}
              required={true}
              id='firstName'
              label={`First name`}
              placeholder={`firstName`}
              errors={errors}
              className='!h-[44px]'
              labelSize='10px'
              errorMessage='This field is mandatory. Please enter the requested information.'
            />

            <InputField
              register={register}
              required={true}
              id='lastName'
              label='Last name'
              placeholder='lastName'
              className='!h-[44px]'
              errors={errors}
              labelSize='10px'
              errorMessage='This field is mandatory. Please enter the requested information.'
            />

            <InputField
              register={register}
              required={true}
              id='email'
              label='Email address'
              placeholder='email'
              className='!h-[44px]'
              errors={errors}
              labelSize='10px'
              errorMessage='This field is mandatory. Please enter the requested information.'
            />
          </div>
          <div className='flex flex-col item-center space-y-[12px]'>
            <InputField
              register={register}
              required={true}
              id='phoneNumber'
              label='Phone number'
              placeholder='phoneNumber'
              className='!h-[44px]'
              errors={errors}
              labelSize='10px'
              errorMessage='This field is mandatory. Please enter the requested information.'
            />
            <InputField
              register={register}
              required={true}
              id='Position'
              label='Position'
              placeholder='Position'
              className='!h-[44px]'
              errors={errors}
              labelSize='10px'
              errorMessage='This field is mandatory. Please enter the requested information.'
            />
            <InputField
              register={register}
              required={true}
              id='linkedInUrl'
              label='LinkedIn URL'
              placeholder='linkedInUrl'
              className='!h-[44px]'
              errors={errors}
              labelSize='10px'
              errorMessage='This field is mandatory. Please enter the requested information.'
            />
          </div>
          <div className='col-span-2'>
            <MultiLineField
              register={register}
              label=''
              required={true}
              innerClassName='!text-text-muted'
              value='Professional background.
People will see this information on Find a Lawyer.'
              id='message'
              errors={errors}
              errorMessage='This field is mandatory. Please enter the requested information.'
            />
          </div>
          <div className='flex col-span-2 justify-end'>
            <button
              // onClick={handleSubmit}
              className={`btn btn-default`}
            >
              Continue
            </button>
          </div>
        </form>
      </div>
    </AccountsLayout>
  )
}

export default ChamberManagerCreation
